import React from 'react';
//Material-ui
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

function GeneralData({ address, name, setAddress, setName }) {
  return (
    <Paper className="general-paper">
      <Typography variant="body1">Información General</Typography>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <TextField
            autoFocus={name ? false : true}
            fullWidth
            label="Domicilio"
            margin="normal"
            onChange={(e) => setAddress(e.target.value)}
            value={address}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Apellidos"
            margin="normal"
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default GeneralData;
